import {
  CREATE_PUBLIC_MANUAL_PAYMENT_INTENT,
  CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_SUCCESS,
  CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_FAILURE,
  RESET_PUBLIC_MANUAL_PAYMENT_INTENT,
} from "./actionType";

const initialState = {
  createIntentData: {},
  createIntentLoading: false,
  createIntentError: null,
};

const PublicManualPayment = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PUBLIC_MANUAL_PAYMENT_INTENT:
      return { ...state, createIntentLoading: true, createIntentError: null };
    case CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_SUCCESS:
      return {
        ...state,
        createIntentData: Array.isArray(action.payload)
          ? action.payload[0]
          : action.payload,
        createIntentLoading: false,
      };
    case CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_FAILURE:
      return {
        ...state,
        createIntentLoading: false,
        createIntentError: action.payload,
      };
    case RESET_PUBLIC_MANUAL_PAYMENT_INTENT:
      return initialState;
    default:
      return state;
  }
};

export default PublicManualPayment;
